import { defineStore } from 'pinia'
import axios from 'axios'
import _ from 'lodash'

export const useGalleryStore = defineStore('gallery', {
	state: () => {
		return {
			galleries: [],
		}
	},
	getters: {
		games: (state) => {
			let allGames = state.galleries.flatMap(({ games }) => games).filter(Boolean)
			let games = [...new Set(allGames.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(games, 'name')
		},
	},
	actions: {
		getGalleries() {
			if (this.galleries.length > 0) return Promise.resolve()
			return axios
				.get('/api/gallery')
				.then((galleries) => {
					this.galleries = galleries.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
